import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeReportICTSystems } from 'store/ducks/Reportings/types';
import { columns } from 'components/Columns/ReportICTSystemsColumns';

interface reportICTSystemsProps {
  entityName: string;
}

const ReportICTSystems: React.FC<reportICTSystemsProps> = ({ entityName }) => {
  const { date, is_additional_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataTypeReportICTSystems[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      date,
    };
    try {
      const fetchedData = await reportingOp.fetchReportICTSystems(params);
      if (fetchedData && Array.isArray(fetchedData.filtered_data)) {
        const date = fetchedData.date;
        const entityName = fetchedData.entity_name;

        const formattedData = fetchedData.filtered_data.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: entityName,
            end_date: dataItem.end_date,
            function_name: dataItem.function_name,
            function_description: dataItem.function_description,
            ict_service_description: dataItem.ict_service_description,
            ict_system_description: dataItem.ict_system_description,
            ict_system_name: dataItem.ict_system_name,
            start_date: dataItem.start_date,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_additional_displayed, entityName]);

  return (
    <>
      <Table columns={columns} dataSource={data} scroll={{ x: 1000, y: 430 }} />
    </>
  );
};

export default ReportICTSystems;
